import { LicenseInfo } from '@mui/x-data-grid-pro';

LicenseInfo.setLicenseKey(
  '273b33a6120ecae5246e0ab11fbf50b4Tz05NjM1OCxFPTE3NTc3MTg4NDAwMDAsUz1wcm8sTE09cGVycGV0dWFsLFBWPWluaXRpYWwsS1Y9Mg==',
);
